export default __webpack_public_path__ + "static/media/Print-07.1b020654.svg";